module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8zMSU"))).then(() => parcelRequire('ikE14'));